import { render, staticRenderFns } from "./relaventSelect.vue?vue&type=template&id=5c033df8&scoped=true&"
import script from "./relaventSelect.vue?vue&type=script&lang=js&"
export * from "./relaventSelect.vue?vue&type=script&lang=js&"
import style0 from "./relaventSelect.vue?vue&type=style&index=0&id=5c033df8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c033df8",
  null
  
)

export default component.exports